import { pushTo } from '@app/core/routing';
import { auditReports, auditReportsApiClient } from '@mi-front/api-clients';
import { ReportExportInfo } from './components/export-info/ReportExportInfo';
import { GipReportActions } from './components/GipReportActions';
import { GipDetails } from './components/GipReportViewShared';

interface Props {
  readonly report: auditReports.GipReportDto;
}

export function GipReportDetail({ report }: Props) {
  return (
    <GipDetails
      report={report}
      actions={
        <GipReportActions
          report={report}
          exportFn={(params) =>
            auditReportsApiClient.generateUrl(
              auditReports.getExportGipReportUrl(report.id).url,
              params,
            )
          }
          onClone={() => {
            pushTo(`/audit/global-reports/gip-report?report=${report.id}`);
          }}
        />
      }
      exportInfo={<ReportExportInfo report={report} />}
    />
  );
}
